// utils
import { addZero } from 'utils';

// constants
import { DEFAULT_DATE_FORTMAT } from 'constants';

//library
import dayjs from 'dayjs';

export function formatDateSaudiToString(date) {
  //객체 + 유효날짜인지 유효성검사
  if (!(date instanceof Date) || !dayjs(date).isValid()) return;

  // 사우디 날짜
  const saudiDate = dayjs(date).tz('Asia/Riyadh');
  return saudiDate.$d;
}

export function formatDateToString(date) {
  //객체 + 유효날짜인지 유효성검사
  if (!(date instanceof Date) || !dayjs(date).isValid()) return;

  // 사우디 날짜
  const saudiDate = dayjs(date).tz('Asia/Riyadh');
  return saudiDate.toDate();
}

export function dateToString(date) {
  return dayjs(date).format(DEFAULT_DATE_FORTMAT);
}

export const formatTimeToString = (date) => {
  let localHour = date.getHours();
  let localMinute = date.getMinutes();

  let amPm;
  if (localHour >= 0 && localHour < 12) {
    amPm = 'AM';
  } else {
    amPm = 'PM';
    if (localHour > 12) {
      localHour -= 12;
      localHour = `0${localHour}`;
    }

    if (localMinute < 10) {
      localMinute = `0${localMinute}`;
    }
  }

  return `${localHour}:${localMinute} ${amPm}`;
};

export const formatDateToStringForEntry = () => {
  // 현재 날짜와 시간을 UTC로 가져옵니다.
  const currentUTCDate = new Date();
  // 사우디 아라비아 시간대의 오프셋 (+3)을 적용합니다.
  const saudiArabiaOffset = 3 * 60; // 분 단위로 변환
  const date = new Date(currentUTCDate.getTime() + saudiArabiaOffset * 60000);

  // 사우디 아라비아 현지 시간 적용
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const dayOfMonth = date.getUTCDate();
  let localHour = date.getUTCHours();
  let localMinute = date.getUTCMinutes();

  return `Update : ${year}-${addZero(month)}-${addZero(dayOfMonth)} ${addZero(
    localHour
  )}:${addZero(localMinute)}`;
};

export const formattedDateEn = (date) => {
  return dayjs(date).locale('en').format('dddd, D MMMM YYYY');
};

export const formattedDateEnShortAndHy = (date) => {
  return dayjs(date).locale('en').format('D-MMM-YYYY');
};

export const formattedDateEnShort = (date) => {
  return dayjs(date).locale('en').format('D MMM YYYY');
};

export const formattedDateEnDay = (date) => {
  const dayName = dayjs(date).format('ddd');
  const dayOfMonth = dayjs(date).format('D');

  return `${dayName} \n ${dayOfMonth}`;
};
